import { Dialog, IconButton, IconClose, BUTTON_VARIANTS } from 'cdk-radial';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import {
  deleteApi,
  storeDeletedApiName,
} from '../../../../../redux/connectedComponent/orderAPI/orderAPI.slice';
import { useEffect } from 'react';
import { AMPLITUDE_EVENTS } from '../../../../../constants/amplitudeConstants';
import {
  getOrgAmplitudeProperties,
  sendAmplitudeData,
} from '../../../../../utils/amplitude';
import { trackManageApiIntegration, getFormattedApiType } from '../../../../../utils/gtm';

const StyledDialog = styled(Dialog)`
  width: 711px;
  height: 190px;
`;

export const APIDelete = (props) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const { authenticationToken: token } = state?.loginDetailsSlice;
  const orgAmplitudeProperties = getOrgAmplitudeProperties(
    state?.loginDetailsSlice
  );
  const { orders, deletingApi } =
    state?.orderAPISlice;
  const { isOpen, handleClose, data } = props;
  const TITLE = 'Delete API';

  const handleDeleteApi = () => {
    const deleteApiResult = dispatch(
      deleteApi({
        orderId: orders?.app?.id,
        apiId: data?.id,
        token,
        apiType: data?.type,
        apiOrgId: data?.orgId,
        appName: orders?.app?.name,
      })
    );

    if (deleteApiResult && typeof deleteApiResult.then === 'function') {
      deleteApiResult.then((action) => {
        if (deleteApi.fulfilled.match(action)) {
          handleClose(true);
        } else if (deleteApi.rejected.match(action)) {
          handleClose(false);
        }
      });
    }

    trackManageApiIntegration({
      actionType: 'Delete',
      apiId: data?.id,
      apiDisplayName: data?.name,
      apiType: getFormattedApiType(data),
      isBundle: false,
    });

    dispatch(storeDeletedApiName({ apiName: data?.name }));
    sendAmplitudeData(
      AMPLITUDE_EVENTS.DELETE_API_CONFIRMATION_DELETE,
      orgAmplitudeProperties
    );
  };

  const handleCancel = () => {
    handleClose(false);
  };

  return (
    <StyledDialog
      id="api-delete-dialog"
      isOpen={isOpen}
      onClose={handleCancel}
      hideHeader
      className="api-delete-dialog"
      buttonsProps={[
        {
          id: 'delete-api-cancel-button',
          onClick: handleCancel,
          text: 'Cancel',
          variant: BUTTON_VARIANTS.SECONDARY,
        },
        {
          id: 'delete-api-button',
          onClick: handleDeleteApi,
          isLoading: deletingApi,
          text: 'Delete',
          variant: BUTTON_VARIANTS.PRIMARY,
        },
      ]}
    >
      <h2 className="api-delete-dialog-warning-heading">
        {TITLE}
        <IconButton
          icon={<IconClose />}
          onClick={handleCancel}
          className="api-delete-close-icon"
          style={{ float: 'right' }}
        />
      </h2>
      <div className="api-delete-dialog-warning-message">
       There are <strong>active subscriptions</strong> to this API. Deleting this API
        Integration will remove these subscriptions. Are you sure you want to
        continue?
      </div>
    </StyledDialog>
  );
};
